module.exports = __webpack_public_path__ + "img/widget_packinglists.d3f752b.svg";